<template>
  <div style="font-size: 14px;">
    <p style="font-weight:600; color: #000;">{{ info.title }}</p>
    <p>{{ info.introduction }}</p>
    <el-button type="primary" style="margin-top: 10px; margin-left: 80px; " size="mini" @click="handleMoveToNotify">查看详情</el-button>
  </div>
</template>

<script>
export default {
  name: 'NotifyComp',
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  methods: {
    handleMoveToNotify() {
      this.$emit('moveToNotify')
    }
  }
}
</script>
